<template>
  <div id="app" >

     <ul id="steps">



      <step
        caption="Votre cadre de jeu"
        link="/section1"
        icon="ti-user"

        rank=1
      ></step>

      <step
        caption="Votre niveau de jeu"
        link="/section2"
        icon="ti-bar-chart"

        rank=2
      ></step>

      <step
        caption="Votre style de jeu"
        link="/section3"
        icon="ti-panel"
        rank=3
      ></step>

      <step
        caption="Votre réponse"
        link="/answer"
        icon="ti-direction"
        rank=4
      ></step>


    </ul>
    <div class="card">
      <div class="card-body">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
</div>
</div>
    <!-- </form-wizard> -->
  </div>
</template>

<script>
import Step from './components/Step.vue'
import Vuex from 'vuex'
export default {
  name: 'App',
  components:{ Step },
  computed: {
    getStoredIP() {
      return this.$store.state.answers.ip
    },

    ...Vuex.mapState(['answers'])
  },
  created: function(){

    if ( this.getStoredIP == "") {

      this.$http.get('https://api.ipgeolocation.io/ipgeo?apiKey=d31cd9e626324e8d844ce1013d912f4b').then(response => {
        console.log(response.data)
        this.$store.commit('updateLocation', response.data)
      })
    }
  }

}

</script>

<style lang="scss">

 @import "assets/_custom.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
@import "assets/_style.scss";
@import "assets/_wizard.scss";

  body {
    margin: 0;
  }

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}
#nav {
  padding: 30px;
  text-align: center;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

fieldset {
  margin-top: 1px;
  legend {

  }
  .custom-control {
    padding-top: 3px;
  }
}

.form-group {
  margin-bottom: 1rem;
  &.action {
    margin-top: 2rem;
  }
}

</style>
